import { createContext, useContext, type ReactNode } from "react";

export type Theme = "dark" | "light" | "system";

export interface ThemeProviderProps {
  children: ReactNode;
  defaultTheme?: Theme;
  storageKey?: string;
}

export interface ThemeProviderState {
  theme: Theme;
  /** A ténylegesen alkalmazott téma a felületen: "dark" vagy "light" */
  resolvedTheme: "dark" | "light";
  setTheme: (theme: Theme) => void;
}

export const initialState: ThemeProviderState = {
  theme: "system",
  resolvedTheme: "light",
  setTheme: () => null,
};

export const ThemeProviderContext = createContext<ThemeProviderState>(initialState);

export function useTheme() {
  const context = useContext(ThemeProviderContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
